import { combineReducers } from 'redux';
import activation from './activation';
import dataExtension from './dataExtension';
import einsteinRecommendations from './einsteinRecommendations';
import eefV2Provisioning from './eefV2Provisioning';
import frequencies from './frequencies';
import notificationSubscribers from './notificationSubscribers';

export default combineReducers({
  activation,
  dataExtension,
  eefV2Provisioning,
  einsteinRecommendations,
  frequencies,
  notificationSubscribers
});
